// import React from "react";
import TextStyle from '@rezdy/components/TextStyle';
import styled from 'styled-components';

const Message = styled(TextStyle as any)`
    padding: ${({ theme }) => theme.component.margin};
    color: ${({ isDirty }) => (isDirty ? '#FA626F' : '#1958D6')};
    background-color: ${({ isDirty }) => (isDirty ? '#feeeef' : '#E5ECFA')};
    margin: ${({ theme }) => theme.component.margin} 0px;
`;

Message.displayName = 'Message';

export default Message;
